import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FuseSidebarService } from "@fuse/components/sidebar/sidebar.service";
import { HelperService } from "app/helpers/helper.service";
import { LogoutService } from "app/helpers/logout.service";
import { UserDataService } from "app/helpers/user-data.service";

@Component({
  selector: "toolbar",
  templateUrl: "./toolbar.component.html",
  styleUrls: ["./toolbar.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ToolbarComponent implements OnInit, OnDestroy {
  hiddenNavbar = false;
  rightNavbar = false;
  horizontalNavbar = false;
  userStatusOptions: any[];
  private _userData: any;
  barrack_id: Number;
  get userData(): any {
    return this._userData;
  }
  set userData(val: any) {
    this._userData = val;
  }

  get barracks(): any {
    return this._userDataService.userData.barracks;
  }

  constructor(
    private _fuseSidebarService: FuseSidebarService,
    private _userDataService: UserDataService,
    private _logoutService: LogoutService,
    private helper: HelperService,
    private _router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.barrack_id = 1;
    this._userData = _userDataService.userData;

    this.activatedRoute.queryParams.subscribe((data) => {
      this.barrack_id = this.helper.getParameters(data["_v"])?.barrack_id ?? 1;
    });
    this._userDataService.barrackChangeEvent.subscribe((val) => {
      this.barrack_id = val;
    });
    // _router.events.subscribe((val) => {
    //   if (val instanceof NavigationEnd) {
    //     this._activatedRoute.queryParams.subscribe((data) => {
    //       var parameters = this._helperService.getParameters(data["_v"]);
    //       if (parameters != null && parameters.hasOwnProperty("barrack_id")) {
    //         let barrack_id = parameters.barrack_id;
    //         this.barrackId = barrack_id;
    //         _cdr.detectChanges();
    //       } else {
    //         this.barrackId = "1";
    //         _cdr.detectChanges();
    //       }
    //     });
    //   }
    // });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  toggleSidebarOpen(key): void {
    this._fuseSidebarService.getSidebar(key).toggleOpen();
  }

  showEmptyProfile(event) {
    event.target.src = "/assets/images/empty_profile_male.jpg";
  }

  logout() {
    this._logoutService.logout();
  }
  showProfile() {
    this._router.navigateByUrl("/user/member_view/self");
  }

  onMenuSelect(menuItem: any) {}
}
